import {ApiResource} from '../../common/base/api-resource';
import {DmsElementMetadataRegResource} from './dms-element-metadata-reg-resource';

export class DmsElementMetadataResource extends ApiResource {
  value: string;
  elementId: number;
  elementMetadataReg?: DmsElementMetadataRegResource;
}
